import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

export function Loader({ onComplete }) {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const hide = setTimeout(() => setShow(false), 1400);
    const complete = setTimeout(() => onComplete?.(), 1900);
    return () => { clearTimeout(hide); clearTimeout(complete); };
  }, [onComplete]);

  const box = "w-14 h-14 sm:w-16 sm:h-16 rounded-2xl flex items-center justify-center text-white font-heading font-extrabold text-3xl";
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[200] flex items-center justify-center bg-white pointer-events-none loader-failsafe"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          data-testid="page-loader"
        >
          <div className="flex gap-3">
            {[
              { c: "#ED1C24", l: "S" },
              { c: "#FF7A00", l: "U" },
              { c: "#FFC400", l: "K" },
            ].map((b, i) => (
              <motion.span
                key={b.l}
                className={box}
                style={{ background: b.c }}
                initial={{ y: 24, opacity: 0, rotate: -8 }}
                animate={{ y: [24, -10, 0], opacity: 1, rotate: 0 }}
                transition={{ duration: 0.8, delay: i * 0.15, repeat: Infinity, repeatType: "reverse", repeatDelay: 0.2 }}
              >
                {b.l}
              </motion.span>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
